import React from "react";
import AsyncSearchField from "../asyncSearch";
import { EntityNameSearchFieldType } from "./type";
import { useFormikContext } from "formik";
import { AnyObject } from "../../../../global";
import client from "../../../datasource/apiClient";
import { FormFieldOption } from "../types";
import { DEFAULT_MAX_RESULTS_COUNT } from "../../../utils/constants";
import { HttpVerb } from "shared/utils/enums";

function EntityNameSearchField<ApiResType>({
  selectHandler,
  resetHandler,
  fetchType = HttpVerb.POST,
  ...props
}: EntityNameSearchFieldType<ApiResType>) {
  const { setFieldValue, values } = useFormikContext();

  const getRequestBody = React.useCallback(
    (name: string) => ({
      name,
      resultCount: DEFAULT_MAX_RESULTS_COUNT,
      ...props.requestBodyObj
    }),
    [props.requestBodyObj]
  );

  const optionSelectedCallback = React.useCallback(
    (optionItem: FormFieldOption, list: Array<ApiResType>) => {
      setFieldValue(props.formEntityIdKeyName, optionItem.value);
      const selectedItem = list.find(i => (i as any).id === optionItem.value);
      selectedItem && selectHandler?.(selectedItem);
    },
    [props.formEntityIdKeyName, setFieldValue, selectHandler]
  );

  const resetCallback = React.useCallback(() => {
    setFieldValue(props.formEntityIdKeyName, "");
    resetHandler?.();
  }, [props.formEntityIdKeyName, setFieldValue, resetHandler]);

  const alreadySelectedOption = React.useMemo(
    () => ({ label: (values as AnyObject)[props.name], value: (values as AnyObject)[props.formEntityIdKeyName] || "" }),
    [props.name, values, props.formEntityIdKeyName]
  );
  const getResponseParser = props.getResponseParser;

  const getApiWrapper = React.useCallback(
    body => {
      if (fetchType === HttpVerb.POST) {
        return client(props.apiUrl, {
          body: body
        });
      }
      return client(props.apiUrl + `?${new URLSearchParams(body).toString()}`).then((res: any) => {
        if (getResponseParser) {
          return getResponseParser(res);
        }
        return res;
      });
    },
    [props.apiUrl, fetchType, getResponseParser]
  );

  return (
    <React.Fragment>
      <AsyncSearchField
        name={props.name}
        label={props.label}
        apiWrapper={getApiWrapper}
        hideLoader={true}
        required={props.required}
        validate={props.validate}
        getRequestBody={getRequestBody}
        placeholder={props.placeholder}
        disabled={props.disabled}
        optionSelectedCallback={optionSelectedCallback}
        resetCallback={resetCallback}
        additionalLabel={props.additionalLabel}
        alreadySelectedOption={alreadySelectedOption}
      />
    </React.Fragment>
  );
}

export default EntityNameSearchField;
